import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Input,
  message,
  Select,
  Space,
  Table,
} from "antd";
import COACH_API from "api/coach";
import moment from "moment";
import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import AUTH_API from "./../../api/auth";
import "./Coach.css";
import Selectbutton from "./Selectbutton";
import StepViewCard from "./StepViewCard";
import { step_names } from './StepNames';
import MyLoader from "Components/PlaceholderLoader/PlaceholderLoader";
import { COLUMNS } from "./Columns";
import HELPERS from "utils/helper";

const { Option } = Select;
const { TextArea } = Input;


//change
const rows = (props) => {
  return <tr {...props} className="tr-a"></tr>;
};
//till here

export default class CoachTable extends React.Component {
  formRef = React.createRef();

  state = {
    selected_date: "",
    api_response: [],
    loading: true,
    fullDataLoading: false,
    searchText: "",
    searchedColumn: "",
    till_index: 10,
    currentIndex: 10,
    loadAllUsers: false
  };

  saveDate = (date, dateString) => {
    // console.log(dateString);
    this.setState({ selected_date: dateString });
  };

  userId = HELPERS.getUserId();

  componentDidMount() {
    // var tableContent = document.querySelector('.ant-table-body');

    if (
      !localStorage.getItem("has_bd") &&
      moment().format("DD-MM") === "25-02"
    ) {
      console.log(moment().format("DD-MM"), "25-02");
      const mes = message.success({
        icon: () => <></>,
        content: (
          <div>
            <img
              src="https://raw.githubusercontent.com/DenverCoder1/Responsive-Birthday-Card/main/birthday.svg"
              alt="birthday"
              className="birthday"
            />
            <div className="text">
              <h1>Happy Birthday Rachel!</h1>
              <p>We hope you have a wonderful birthday</p>
              <p className="muted"></p>
            </div>
            <div className="spaced"></div>
          </div>
        ),
        className: "custom-class",
        // duration:2000,
        style: {
          marginTop: "20vh",
        },
      });
      localStorage.setItem("has_bd", true);
      setTimeout(mes, 4500);
    } else {
      console.log("dont show");
    }

    console.log("id in get api is:", this.props.id);

    // AUTH_API.CoachListView()
    //   .then((response) => {
    //     // console.log("get api response", response);
    //     let temp = [...response.data];
    //     let temp2 = [];
    //     temp.forEach((item) => {
    //       if (item.is_active) {
    //         if (item.status !== "HO") {
    //           temp2.push(item);
    //         }
    //       }
    //     });
    //     console.log("tem", temp2);
    //     this.setState({ api_response: temp2, loading: false });
    //   })
    //   .catch((err) => {
    //     console.log("get api error", err);
    //     // this.setState({ loading: false });
    //   });

    // AUTH_API.CoachListView()
    // .then((response) => {
    //   this.setState({ loading: false });  

    //   console.log("yyyy get api response", typeof (response), response);

    //   const filteredData = [];
    //   for (let i = 0; i < response.data.length && filteredData.length < 2; i++) {
    //     const item = response.data[i];
    //     if (item.is_active && item.status !== "HO") {
    //       filteredData.push(item);
    //     }
    //   }

    //   console.log("yyyy filter", filteredData);
      
    //   // Only update state once
    //   // After loading state is updated, set the filtered data in a callback
    //   // This separates the UI update from the data update
    //   // this.setState({ api_response: filteredData });
      
    //   const loadNextBatch = () => {
    //     const { currentIndex, api_response } = this.state;
    //     const nextBatch = [];
      
    //     let count = 0;
    //     for (let i = currentIndex; i < response.data.length && count < 2; i++) {
    //       const item = response.data[i];
    //       if (item.is_active && item.status !== "HO") {
    //         nextBatch.push(item);
    //         count++;
    //       }
    //     }
      
    //     this.setState({
    //       api_response: [...api_response, ...nextBatch],
    //       currentIndex: currentIndex + count,
    //     });
    //   };
      
    //   this.setState({
    //     currentIndex: 2,
    //     api_response: filteredData,
    //   }, () => {
    //     // loadNextBatch(); // Load the first 20 items
    //   });

    //   console.log("yyyy state", this.state.api_response, this.state.loading );

    // })
    // .catch((err) => {
    //   console.log("get api error", err);
    //   this.setState({ loading: false }); // Always update loading state on error
    // });

    


    // const cache = JSON.parse(localStorage.getItem("tableData"));
    // if (!cache) {
    //   this.fetchData();
    // }
    // else{
    //   this.setState({ api_response: cache, loading: false });
    //   setTimeout(() => {
    //     this.fetchData();
    //   }, 2000);    
    // }

    AUTH_API.CoachListView()
    .then((response) => {
      this.setState({ loading: false });

      console.log('yyy  api data', response);

      this.fullResponseData = response.data.filter(
        (item) => item.is_active && item.status !== "HO"
      );
      
      const initialBatch = [];
      const data = this.fullResponseData;
      // const length = data.length > 10 ? 10 : data.length;
      const length = data.length > 0 ? data.length : 200;

      for (let i = 0; i < length; i++) {
        initialBatch.push(data[i]);
      }

      console.log('yyy  first 10 data', initialBatch);

      this.setState({ api_response: initialBatch, fullDataLoading: false });

      // const button = document.querySelector('.load-all-users');
      // setTimeout(() => {
      //   if (button) {
      //     button.click(); // Trigger the click event
      //   }
      // }, 5000);

      // this.setState({ api_response_complete: this.fullResponseData });

      console.log('yyy  setState', this.state.api_response);
    })
    .catch((err) => {
      console.log("API error:", err);
      this.setState({ loading: false });
    });

  }

  loadAllUsers = () => {
    console.log('yyy load all data', this.state.api_response_complete);
    this.setState(
      {
        loadAllUsers: true,
        fullDataLoading: false,
      },
    );
  };

  fetchData = () => {
    AUTH_API.CoachListView()
    .then((response) => {
      // console.log("get api response", response);
      let temp = [...response.data];
      let temp2 = [];
      temp.forEach((item) => {
        if (item.is_active) {
          if (item.status !== "HO") {
            temp2.push(item);
          }
        }
      });
      console.log("tem", temp2);
      this.setState({ api_response: temp2, loading: false });
      
      localStorage.setItem("tableData", JSON.stringify(this.state.api_response));
    })
    .catch((err) => {
      console.log("get api error", err);
    });
  }

  patchUser = (data, id) => {
    AUTH_API.CoachListPatch(data, id)
      .then((response) => {
        console.log("patch api response", response);
      })
      .catch((err) => {
        console.log("patch api error", err);
      });
  };

  OnFormChange = (e, field, id, datestring) => {
    console.log(e, field, id, datestring);
    if (field === "last_communication_mode") {
      const data = {
        last_communication_mode: e,
      };
      this.patchUser(data, id);
    }
    if (field === "last_communication_by") {
      const data = {
        last_communication_by: e.target.value,
      };
      console.log("data is:", data);
      this.patchUser(data, id);
    }
    if (field === "last_communicated_on") {
      const data = {
        last_communicated_on: datestring,
      };
      this.patchUser(data, id);
    }
    if (field === "coach_notes") {
      const data = {
        coach_notes: e.target.value,
        userId: this.userId,
      };
      this.patchUser(data, id);
      console.log("newdata is:", data);
    }
    if (field === "last_call") {
      const data = {
        last_call: datestring,
      };
      this.patchUser(data, id);
    }
  };

  impersonate = (clientId) => {
    console.log("client id", clientId);
    // if (localStorage.getItem("impersonating")) {
    //   message.error("Please stop impersonating the other client first, or refresh.");
    // } else {
    COACH_API.impersonate(clientId)
      .then((resp) => {
        localStorage.setItem("user_id", clientId);
        // localStorage.setItem("user_id", "387");
        // localStorage.setItem("impersonating", true);
        // window.open(`${window.location.origin}/dashboard`, "_blank");
        // window.open(`${window.location.origin}/dashboard`)
        window.location.href = "/";
        // console.log("imporsonate resp:",resp);
      })
      .catch((err) => {
        message.error("Won't be able to impersonate this client!");
        // console.log("impersonate error: ", err)
      });
    // }
  };

  setupCall = (obj, text) => {
    const data = {
      id: obj.id,
      step: obj.step,
      status: "UN",
    };
    const id = obj.id;
    console.log("patch api data:", data, "step_id", id);
    AUTH_API.CoachStepsPatch(data, id)
      .then((response) => {
        console.log("patch api response for popups", response);
        message.success("User Notified ");
      })
      .catch((err) => {
        console.log("patch api error", err);
      });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, minHeight: "unset", display: "flex", alignItems: "center" }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90, minHeight: "unset" }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#E5F2F3"/>
      <path d="M23.5 23.5002L19.8809 19.881M19.8809 19.881C20.5 19.2619 20.991 18.527 21.3261 17.7181C21.6611 16.9093 21.8336 16.0423 21.8336 15.1668C21.8336 14.2913 21.6611 13.4244 21.3261 12.6155C20.991 11.8067 20.5 11.0717 19.8809 10.4527C19.2618 9.8336 18.5269 9.34252 17.718 9.00748C16.9091 8.67244 16.0422 8.5 15.1667 8.5C14.2912 8.5 13.4243 8.67244 12.6154 9.00748C11.8066 9.34252 11.0716 9.8336 10.4525 10.4527C9.20227 11.7029 8.49988 13.3987 8.49988 15.1668C8.49988 16.935 9.20227 18.6307 10.4525 19.881C11.7028 21.1313 13.3986 21.8337 15.1667 21.8337C16.9349 21.8337 18.6306 21.1313 19.8809 19.881Z" stroke="#199094" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    {/* <SearchOutlined style={{ color: "#199094", backgroundColor: "#E5F2F3", padding: "6px", borderRadius: "100%" }} />, */}
    </>,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text, record) =>
      this.state.searchedColumn === dataIndex ? (
        <>
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
          <div
            style={{
              display: "flex",
              columnGap: "10px",
              alignItems: "center",
            }}
          >
            <Link
              to={{
                pathname: `/coach/drill-down`,
                id: record.client_id,
                userName: record.client,
              }}
              onClick={() =>
                localStorage.setItem("current_drilldown", record.client_id)
              }
              className="drill-down-text"
              style={{ color: "#888888 !important", fontSize: "12px" }}
              >Drill Down&nbsp;&nbsp;
              <img className="imp-image-l" src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/coachDashboardDrillDown.svg" />
            </Link>
            <span className="bullet-point"></span>
            <div style={{color: "#888888 !important", fontSize: "12px"}} onClick={() => this.impersonate(record.client_id)} className="view-profile-text">View Profile&nbsp;&nbsp;<img className="imp-image-r" src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/coachDashboardViewProfile.svg" /></div>
          </div>
        </>
      ) : (
        <>
          <span style={{width: "fit-content"}}>{text}</span>
          <div
            style={{
              display: "flex",
              columnGap: "10px",
              alignItems: "center",
            }}
          >
            <Link
              to={{
                pathname: `/coach/drill-down`,
                id: record.client_id,
                userName: record.client,
              }}
              onClick={() =>
                localStorage.setItem("current_drilldown", record.client_id)
              }
              className="drill-down-text"
              style={{ color: "#888888 !important", fontSize: "12px" }}
              >Drill Down&nbsp;&nbsp;
              <img className="imp-image-l" src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/coachDashboardDrillDown.svg" />
            </Link>
            <span className="bullet-point"></span>
            <div style={{color: "#888888 !important", fontSize: "12px"}} onClick={() => this.impersonate(record.client_id)} className="view-profile-text">View Profile&nbsp;&nbsp;<img  className="imp-image-r" src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/coachDashboardViewProfile.svg" /></div>
          </div>
        </>
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  handleScroll = (e) => {
    let bottom =
      e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
    if (bottom === 0) {
      let n = this.state.till_index;
      n = n + 10;
      this.setState({ till_index: n });
    }
  };

  time_convert = (num) => {
    if (num > 59) {
      var hours = Math.floor(num / 60);
      var minutes = num % 60;
      return hours + " hrs " + minutes + " mins";
    } else {
      return num + " mins";
    }
  };

  getUserstatus = (days) => {
    // console.log("days since last use:", days);
    if (days > 14) return "Inactive";
    if (days >= 7) return "Light Active";
    if (days < 7) return "Active";
    else return "On Hold";
  };

  render() {
    console.log("new Render");
  }

  render() {
    // console.log("satyam coach api response", this.state.api_response);
    
    // const columns = [
    //   {
    //     title: "Client",
    //     width: "190px",
    //     dataIndex: "client",
    //     key: "client",
    //     fixed: "left",
    //     className: "col-class",
    //     sorter: {
    //       compare: (a, b) =>
    //         a.client
    //           ? a.client
    //               .toString()
    //               .localeCompare(b.client.toString())
    //           : true,
    //       //
    //     },
    //     defaultSortOrder: "ascend",
    //     // render:(text)=>(
    //     //             <>
    //     //                 <h3 style={{fontSize:'14px'}}>{text}</h3>
    //     //                 <div>
    //     //                 <Link to ={`/coach/drill-down`} style={{color:'inherit !important'}}><span className='imp-image-l'></span></Link>
    //     //                     
    //     //                     <span className='imp-image-r'></span>
    //     //                 </div>
    //     //             </>
    //     //             ),
    //     ...this.getColumnSearchProps("client"),
    //   },
    //   // {
    //   //   title: "Last Communication",
    //   //   dataIndex: "last_comm_on",
    //   //   key: "1",
    //   //   width: "250px",
    //   //   hidden: true,
    //   //   // width: "200px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.last_comm_on
    //   //         ? a.last_comm_on
    //   //             .toString()
    //   //             .localeCompare(b.last_comm_on.toString())
    //   //         : true,
    //   //     //
    //   //   },
    //   //   render: (text, record) => (
    //   //     <>
    //   //       <div>
    //   //         <span style={{ fontSize: "14px" }} className="sms-span">
    //   //           <Select
    //   //             style={{ width: 70 }}
    //   //             bordered={false}
    //   //             defaultValue={record.last_comm === "TE" ? "SMS" : "Email"}
    //   //             onChange={(e) =>
    //   //               this.OnFormChange(
    //   //                 e,
    //   //                 "last_communication_mode",
    //   //                 record.client_id
    //   //               )
    //   //             }
    //   //           >
    //   //             <Option value="TE">SMS</Option>
    //   //             <Option value="EM">Email</Option>
    //   //           </Select>
    //   //           By &nbsp;&nbsp;
    //   //         </span>
    //   //         <Input
    //   //           className="lco-inp"
    //   //           defaultValue={
    //   //             record.last_comm_by ? record.last_comm_by : "Rachel"
    //   //           }
    //   //           onBlur={(e) =>
    //   //             this.OnFormChange(
    //   //               e,
    //   //               "last_communication_by",
    //   //               record.client_id
    //   //             )
    //   //           }
    //   //         ></Input>
    //   //         {/* <span style={{opacity:'50%',fontSize:'12px'}}>Anna Tim</span> */}
    //   //       </div>
    //   //       <div>
    //   //         <DatePicker
    //   //           style={{ padding: "0", width: "120px" }}
    //   //           defaultValue={
    //   //             record.last_comm_on._isValid ? record.last_comm_on : null
    //   //           }
    //   //           onChange={(date, datestring) =>
    //   //             this.OnFormChange(
    //   //               date,
    //   //               "last_communicated_on",
    //   //               record.client_id,
    //   //               datestring
    //   //             )
    //   //           }
    //   //           bordered={false}
    //   //         />
    //   //       </div>
    //   //     </>
    //   //   ),
    //   // },
    //   {
    //     title: "Start Date",
    //     dataIndex: "startdate",
    //     key: "3",
    //     width: "95px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       compare: (a, b) =>
    //         {
    //           // return a.startdate ? a.startdate.localeCompare(b.startdate) : true
    //           let dateA = a.startdate ? new Date(a.startdate) : new Date(0); // Default to epoch if empty
    //           let dateB = b.startdate ? new Date(b.startdate) : new Date(0);
    //           // console.log("start_date", a.startdate, b.startdate, dateA, dateB)

    //           return dateA - dateB; // Numeric comparison for dates
    //         }
    //     },
    //   },
    //   {
    //     title: "Total Time spent",
    //     dataIndex: "time_spent",
    //     key: "4",
    //     width: "130px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       compare: (a, b) =>
    //         a.time_spent_comp
    //           ? a.time_spent_comp < b.time_spent_comp
    //             ? 1
    //             : -1
    //           : true,
    //     },
    //   },
    //   {
    //     title: "Last Meeting",
    //     dataIndex: "last_call",
    //     key: "5",
    //     width: "150px",
    //     height: "100px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       compare: (a, b) =>
    //         {
    //           // return a.last_call ? a.last_call.isAfter(b.last_call) ? -1 : 1 : true

    //           // Handle cases where last_call is invalid or missing
    //           if (!a.last_call || !a.last_call.isValid()) return 1;  // Move invalid/missing dates to the bottom
    //           if (!b.last_call || !b.last_call.isValid()) return -1;

    //           // Compare valid moment objects
    //           return a.last_call.isBefore(b.last_call) ? -1 : 1;
    //         }
    //     },
    //     render: (text, record) => (
    //       <>
    //         {/* {console.log('last_call',text,typeof text)} */}
    //         <DatePicker
    //           style={{ padding: "0" }}
    //           defaultValue={text._isValid ? text : null}
    //           className="lc-input"
    //           format="MMM DD, YYYY"
    //           onChange={(date, datestring) =>
    //             this.OnFormChange(
    //               date,
    //               "last_call",
    //               record.client_id,
    //               moment(datestring).format("YYYY-MM-DD")
    //             )
    //           }
    //           bordered={false}
    //         />
    //       </>
    //     ),
    //   },
    //   {
    //     title: "Coach Notes",
    //     dataIndex: "coachnotes",
    //     key: "6",
    //     width: "140px",
    //     className: "col-coach-notes white-background-cell",
    //     // width: "150px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       // compare: (a, b) =>
    //       //   a.con_obj ? a.con_obj.status.localeCompare(b.con_obj.status) : false,
    //     },
    //     render: (text, record) => (
    //       <TextArea
    //         className="coach-notes-textarea"
    //         rows={2}
    //         onChange={(val) =>
    //           this.OnFormChange(val, "coach_notes", record.client_id)
    //         }
    //         defaultValue={record.coach_notes}
    //       />
    //     ),
    //   },

    //   {
    //     title: "Status",
    //     dataIndex: "status",
    //     key: "7",
    //     width: "90px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       compare: (a, b) =>
    //         a.status ? a.status.localeCompare(b.status) : false,
    //     },
    //     render: (text, record) => (
    //       <>
    //         <button
    //           className="status-btn"
    //           style={{
    //             background:
    //               record.status === "Active"
    //                 ? "#D1FBBD"
    //                 : record.status === "Light Active"
    //                 ? "#FFFBD9"
    //                 : "#FBBDBD",
    //             color:
    //               record.status === "Active"
    //                 ? "#0A8A1D"
    //                 : record.status === "Light Active"
    //                 ? "#C8B700"
    //                 : "#8a0a0a",
    //             cursor: "default",
    //           }}
    //           status={record.status}
    //         >
    //           {record.status}
    //         </button>
    //       </>
    //     ),
    //   },
    //   {
    //     title: "Last Activity",
    //     dataIndex: "last_activity_days",
    //     key: "2",
    //     width: "110px",
    //     showSorterTooltip: false,
    //     sorter: {
    //       compare: (a, b) =>
    //         a.last_activity
    //           ? a.last_activity.localeCompare(b.last_activity)
    //           : true,
    //     },
    //     render: (text, record) => (
    //       <>
    //       {/* {step_names[steps.indexOf(record.last_activity_step)] ? */}
    //       {step_names[record.last_activity_step] ?
    //         <>
    //           <h3 style={{ fontSize: "12px", marginBottom: "2px", }}>
    //             {record.last_activity_days} days ago
    //           </h3>
    //           <div style={{ color: "#888888", fontSize: "9px" }}>
    //             {/* {step_names[steps.indexOf(record.last_activity_step)]} */}
    //             {step_names[record.last_activity_step]}
    //           </div>
    //         </>
    //       :
    //        <>
    //         <h3 style={{ fontSize: "12px", marginBottom: "0" }}>
    //           {record.last_activity_days} days ago
    //         </h3>
    //        </>
    //       }
    //       </>
    //     ),
    //   },
    //   // {
    //   //   title: 'Onboarding', dataIndex: 'on_obj', key: '8',
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) => (a.on_obj) ? a.on_obj.status.localeCompare(b.on_obj.status) : false,
    //   //
    //   //   },
    //   //   render:(text,record)=>(
    //   //      record.on_obj &&  <Selectbutton step_obj={record.on_obj} />
    //   //     )
    //   // },
    //   {
    //     title: "Last Step Completed",
    //     dataIndex: "lsc_obj",
    //     key: "30",
    //     width: "180px",
    //     className: "white-background-cell",
    //     showSorterTooltip: false,
    //     sorter: {
    //       // compare: (a, b) =>
    //       //   a.lsc_obj ? a.lsc_obj.status.localeCompare(b.lsc_obj.status) : false,
    //     },
    //     render: (text, record) =>
    //       record.lsc_obj && (
    //         <>
    //           <StepViewCard step_obj={record.lsc_obj} status_cat="last-step-completed"/>
    //         </>
    //       ),
    //   },
    //   {
    //     title: "Ready For Review",
    //     dataIndex: "rfr_obj",
    //     key: "31",
    //     width: "570px",
    //     className: "white-background-cell",
    //     showSorterTooltip: false,
    //     sorter: {
    //       // compare: (a, b) =>
    //       //   a.rfr_obj ? a.rfr_obj.status.localeCompare(b.rfr_obj.status) : false,
    //     },
    //     render: (text, record) =>
    //       record.rfr_obj && (
    //         <>
    //           <StepViewCard step_obj={record.rfr_obj} status_cat="for-review"/>
    //         </>
    //       ),
    //   },
    //   {
    //     title: "Client Requested Access To",
    //     dataIndex: "rac_obj",
    //     key: "32",
    //     width: "570px",
    //     className: "white-background-cell",
    //     showSorterTooltip: false,
    //     sorter: {
    //       // compare: (a, b) =>
    //       //   a.rac_obj ? a.rac_obj.status.localeCompare(b.rac_obj.status) : false,
    //     },
    //     render: (text, record) =>
    //       record.rac_obj && (
    //         <>
    //           <StepViewCard step_obj={record.rac_obj} status_cat="request-access"/>
    //         </>
    //       ),
    //   },
    //   {
    //     title: "Steps in Progress",
    //     dataIndex: "sip_obj",
    //     key: "33",
    //     width: "570px",
    //     className: "white-background-cell",
    //     showSorterTooltip: false,
    //     sorter: {
    //       // compare: (a, b) =>
    //       //   a.sip_obj ? a.sip_obj.status.localeCompare(b.sip_obj.status) : false,
    //     },
    //     render: (text, record) =>
    //       record.sip_obj && (
    //         <>
    //           <StepViewCard step_obj={record.sip_obj} status_cat="steps-in-progress"/>
    //         </>
    //       ),
    //   },
    //   // {
    //   //   title: "Assessment",
    //   //   dataIndex: "as_obj",
    //   //   key: "9",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.as_obj ? a.as_obj.status.localeCompare(b.as_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.as_obj && (
    //   //       <>
    //   //         <Selectbutton step_obj={record.as_obj} />
    //   //       </>
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Target - Roles",
    //   //   dataIndex: "tr_obj",
    //   //   key: "10",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.tr_obj ? a.tr_obj.status.localeCompare(b.tr_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.tr_obj && <Selectbutton step_obj={record.tr_obj} />,
    //   // },
    //   // {
    //   //   title: "Target - Industries",
    //   //   dataIndex: "ti_obj",
    //   //   key: "11",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ti_obj ? a.ti_obj.status.localeCompare(b.ti_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ti_obj && <Selectbutton step_obj={record.ti_obj} />,
    //   // },
    //   // {
    //   //   title: "Research - Roles",
    //   //   dataIndex: "rr_obj",
    //   //   key: "12",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.rr_obj ? a.rr_obj.status.localeCompare(b.rr_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.rr_obj && <Selectbutton step_obj={record.rr_obj} />,
    //   // },
    //   // {
    //   //   title: "Research - Industries",
    //   //   dataIndex: "ri_obj",
    //   //   key: "13",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ri_obj ? a.ri_obj.status.localeCompare(b.ri_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ri_obj && <Selectbutton step_obj={record.ri_obj} />,
    //   // },
    //   // {
    //   //   title: "Contacts",
    //   //   dataIndex: "co_obj",
    //   //   key: "14",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.co_obj ? a.co_obj.status.localeCompare(b.co_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.co_obj && <Selectbutton step_obj={record.co_obj} />,
    //   // },
    //   // {
    //   //   title: "Email Drafts",
    //   //   dataIndex: "ed_obj",
    //   //   key: "15",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ed_obj ? a.ed_obj.status.localeCompare(b.ed_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ed_obj && <Selectbutton step_obj={record.ed_obj} />,
    //   // },
    //   // {
    //   //   title: "Setup Call with Coach",
    //   //   dataIndex: "midway",
    //   //   key: "16",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   render: (text, record) =>
    //   //     record.mi_obj && (
    //   //       <Button
    //   //         className="midway-btn"
    //   //         onClick={() => this.setupCall(record.mi_obj, "setup-call")}
    //   //       >
    //   //         Setup A Call
    //   //       </Button>
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Networking - Tracker",
    //   //   dataIndex: "nt_obj",
    //   //   key: "17",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.nt_obj ? a.nt_obj.status.localeCompare(b.nt_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.nt_obj && (
    //   //       <Selectbutton
    //   //         step_obj={record.nt_obj}
    //   //         cn_obj={record.cn_obj}
    //   //         cp_obj={record.cp_obj}
    //   //       />
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Call Prep & Call Notes",
    //   //   dataIndex: "cp_obj",
    //   //   key: "18",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.cp_obj ? a.cp_obj.status.localeCompare(b.cp_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.cp_obj && (
    //   //       <Selectbutton step_obj={record.cp_obj} cn_obj={record.cn_obj} />
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Networking Reflections",
    //   //   dataIndex: "nr_obj",
    //   //   key: "19",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.nr_obj ? a.nr_obj.status.localeCompare(b.nr_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.nr_obj && <Selectbutton step_obj={record.nr_obj} />,
    //   // },
    //   // {
    //   //   title: "Experiential Learning",
    //   //   dataIndex: "ex_obj",
    //   //   key: "20",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ex_obj ? a.ex_obj.status.localeCompare(b.ex_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ex_obj && <Selectbutton step_obj={record.ex_obj} />,
    //   // },
    //   // {
    //   //   title: "Next phase",
    //   //   dataIndex: "next-phase",
    //   //   key: "21",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   render: (text, record) =>
    //   //     record.mi_obj && (
    //   //       <Button
    //   //         className="midway-btn"
    //   //         onClick={() => this.setupCall(record.np_obj, "nextphase")}
    //   //       >
    //   //         Release
    //   //       </Button>
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Professional Summary",
    //   //   dataIndex: "ps_obj",
    //   //   key: "22",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ps_obj ? a.ps_obj.status.localeCompare(b.ps_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ps_obj && <Selectbutton step_obj={record.ps_obj} />,
    //   // },
    //   // {
    //   //   title: "Resume",
    //   //   dataIndex: "re_obj",
    //   //   key: "23",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.re_obj ? a.re_obj.status.localeCompare(b.re_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.re_obj && <Selectbutton step_obj={record.re_obj} />,
    //   // },
    //   // {
    //   //   title: "Cover letter",
    //   //   dataIndex: "cl_obj",
    //   //   key: "24",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.cl_obj ? a.cl_obj.status.localeCompare(b.cl_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.cl_obj && <Selectbutton step_obj={record.cl_obj} />,
    //   // },
    //   // {
    //   //   title: "LinkedIn",
    //   //   dataIndex: "li_obj",
    //   //   key: "25",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.li_obj ? a.li_obj.status.localeCompare(b.li_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.li_obj && <Selectbutton step_obj={record.li_obj} />,
    //   // },
    //   // {
    //   //   title: "Application - Tracker",
    //   //   dataIndex: "at_obj",
    //   //   key: "26",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.at_obj ? a.at_obj.status.localeCompare(b.at_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.at_obj && (
    //   //       <Selectbutton step_obj={record.at_obj} ir_obj={record.ir_obj} />
    //   //     ),
    //   // },
    //   // {
    //   //   title: "Interview - Research",
    //   //   dataIndex: "ir_obj",
    //   //   key: "27",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.ir_obj ? a.ir_obj.status.localeCompare(b.ir_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.ir_obj && <Selectbutton step_obj={record.ir_obj} />,
    //   // },
    //   // {
    //   //   title: "Behavioral - Int. Prep",
    //   //   dataIndex: "bp_obj",
    //   //   key: "28",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.bp_obj ? a.bp_obj.status.localeCompare(b.bp_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.bp_obj && <Selectbutton step_obj={record.bp_obj} />,
    //   // },
    //   // {
    //   //   title: "Job Search Reflections",
    //   //   dataIndex: "jr_obj",
    //   //   key: "29",
    //   //   width: "150px",
    //   //   showSorterTooltip: false,
    //   //   sorter: {
    //   //     compare: (a, b) =>
    //   //       a.jr_obj ? a.jr_obj.status.localeCompare(b.jr_obj.status) : false,
    //   //   },
    //   //   render: (text, record) =>
    //   //     record.jr_obj && <Selectbutton step_obj={record.jr_obj} />,
    //   // },
    // ];

    const columns = COLUMNS(this.getColumnSearchProps, this.OnFormChange)
    
    const steps_in_progress_static_obj = [
      {
        date: moment(),
        step_name: "Portfolio/Website",
        step: "PW",
      },
      {
        date: moment(),
        step_name: "Places to Network",
        step: "PN",
      },
      {
        date: moment(),
        step_name: "Onboarding 30/60/90",
        step: "OD",
      },
      // {
      //   date: moment(),
      //   step_name: "Onboarding 30/60/90",
      //   step: "OD",
      // },
      // {
      //   date: moment(),
      //   step_name: "Onboarding 30/60/90",
      //   step: "OD",
      // }
    ]
    const ready_for_review_static_obj = [
      {
        date: moment(),
        step_name: "Professional Summary",
        step: "PS",
      },
      {
        date: moment(),
        step_name: "Target Roles/Industries",
        step: "AE",
      },
      {
        date: moment(),
        step_name: "Soft Skill Development",
        step: "SD",
      },
      // {
      //   date: moment(),
      //   step_name: "Influence & Visibility",
      //   step: "IV",
      // },
      // {
      //   date: moment(),
      //   step_name: "Influence & Visibility",
      //   step: "IV",
      // },
      // {
      //   date: moment(),
      //   step_name: "Influence & Visibility",
      //   step: "IV",
      // },
    ]
    const client_requested_access_to_static_obj = [
      {
        date: moment(),
        step_name: "Professional Summary",
        step: "PS",
        notes: "Need this access",
      },
      {
        date: moment(),
        step_name: "Target Roles/Industries",
        step: "AE",
        notes: "Need this access",
      },
      {
        date: moment(),
        step_name: "Soft Skill Development",
        step: "SD",
        notes: "Need this access",
      },
      {
        date: moment(),
        step_name: "Influence & Visibility",
        step: "IV",
        notes: "Need this access",
      },
      {
        date: moment(),
        step_name: "Influence & Visibility",
        step: "IV",
        notes: "Need this access",
      },
      {
        date: moment(),
        step_name: "Influence & Visibility",
        step: "IV",
        notes: "Need this access",
      },
    ]
    const last_step_completed_static_obj = [
      {
        date: moment(),
        step_name: "Relationship Management",
        step: "RM",
      },
    ]

    // const data = this.state.api_response.map((item, index) => ({
    //   client_id: item.id,
    //   key: index + 1,
    //   client: item.name,
    //   last_activity_step: item.activity,
    //   lastactivity: item.last_activity,
    //   last_comm: item.last_communication_mode,
    //   last_comm_on: moment(item.last_communicated_on),
    //   last_comm_by: item.last_communication_by,
    //   startdate: item.start_date && moment(item.start_date).isValid() ? moment(item.start_date).format("MMM DD, YYYY") : "",
    //   time_spent:
    //     item.time_spent !== null ? this.time_convert(item.time_spent) : "",
    //   time_spent_comp: parseInt(item.time_spent),
    //   last_activity_days: moment().diff(
    //     item.last_activity === null ? moment() : moment(item.last_activity),
    //     "days"
    //   ),
    //   last_activity: item.last_activity,
    //   last_call: moment(item.last_call),
    //   status:
    //     item.status === "HO"
    //       ? "On Hold"
    //       : this.getUserstatus(
    //           moment().diff(
    //             item.last_activity === null
    //               ? moment()
    //               : moment(item.last_activity),
    //             "days"
    //           )
    //         ),
    //   coach_notes: item.coach_notes,
    //   // on_obj:
    //   //   this.state.loading === false
    //   //     ? item.stepreflection_set.length > 0
    //   //       ? item.stepreflection_set.filter((item) => item.step === "ON")[0]
    //   //       : ""
    //   //     : "",
    //   // sip_obj: steps_in_progress_static_obj,
    //   // lsc_obj: last_step_completed_static_obj,
    //   // rfr_obj: ready_for_review_static_obj,
    //   // rac_obj: client_requested_access_to_static_obj,
    //   sip_obj:
    //     this.state.loading === false
    //       ? item.steps_in_progress?.length > 0
    //         ? item.steps_in_progress
    //         : ""
    //       : "",
    //   lsc_obj:
    //       this.state.loading === false
    //         ? item.last_step_completed?.length > 0
    //           ? item.last_step_completed
    //           : ""
    //         : "",
    //   rfr_obj:
    //       this.state.loading === false
    //         ? item.ready_for_review?.length > 0
    //           ? item.ready_for_review
    //           : ""
    //         : "",
    //   rac_obj:
    //     this.state.loading === false
    //       ? item.request_access.length > 0
    //         ? item.request_access
    //         : ""
    //       : "",
    //   as_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "AS")[0]
    //         : ""
    //       : "",
    //   tr_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         // ? item.stepreflection_set.filter((item) => item.step === "TR")[0]
    //         ? item.stepreflection_set.filter((item) => item.step === "AE")[0]
    //         : ""
    //       : "",
    //   ti_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "TI")[0]
    //         : ""
    //       : "",
    //   rr_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "RR")[0]
    //         : ""
    //       : "",
    //   ri_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "RI")[0]
    //         : ""
    //       : "",
    //   co_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "CO")[0]
    //         : ""
    //       : "",
    //   ed_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "ED")[0]
    //         : ""
    //       : "",
    //   mi_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "MI")[0]
    //         : ""
    //       : "",
    //   nt_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "NT")[0]
    //         : ""
    //       : "",
    //   cp_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "CP")[0]
    //         : ""
    //       : "",
    //   cn_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "CN")[0]
    //         : ""
    //       : "",
    //   nr_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "NF")[0]
    //         : ""
    //       : "",
    //   ex_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "LO")[0]
    //         : ""
    //       : "",
    //   np_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "NP")[0]
    //         : ""
    //       : "",
    //   ps_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "PS")[0]
    //         : ""
    //       : "",
    //   re_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "RE")[0]
    //         : ""
    //       : "",
    //   cl_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "CL")[0]
    //         : ""
    //       : "",
    //   li_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "LK")[0]
    //         : ""
    //       : "",
    //   at_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "AT")[0]
    //         : ""
    //       : "",
    //   ir_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "IR")[0]
    //         : ""
    //       : "",
    //   bp_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "BP")[0]
    //         : ""
    //       : "",
    //   jr_obj:
    //     this.state.loading === false
    //       ? item.stepreflection_set.length > 0
    //         ? item.stepreflection_set.filter((item) => item.step === "JR")[0]
    //         : ""
    //       : "",
    //
    // }));
    


    let usersFromApi = this.state.loadAllUsers ? this.state.api_response_complete : this.state.api_response;
  
    usersFromApi = usersFromApi || []; // Fallback to empty array if undefined

    const data = usersFromApi.map((item, index) => {

      const lastActivity = item.last_activity ? moment(item.last_activity) : moment();
      const lastActivityDays = moment().diff(lastActivity, "days");
      // const hasStepReflections = !this.state.loading && item.stepreflection_set && item.stepreflection_set.length > 0;
      
      // let stepReflections = {};
      // if (hasStepReflections) {
      //   // Build a map of step codes to their objects - this avoids repeated filtering
      //   stepReflections = item.stepreflection_set.reduce((acc, reflection) => {
      //     acc[reflection.step] = reflection;
      //     return acc;
      //   }, {});
      // }
    
      return {     
        client_id: item.id,
        key: index + 1,
        client: item.name,
        last_activity_step: item.activity,
        lastactivity: item.last_activity,
        last_comm: item.last_communication_mode,
        last_comm_on: moment(item.last_communicated_on),
        last_comm_by: item.last_communication_by,
        startdate: item.start_date,
        time_spent: item.time_spent !== null ? this.time_convert(item.time_spent) : "",
        time_spent_comp: parseInt(item.time_spent),
        last_activity_days: lastActivityDays,
        last_activity: item.last_activity,
        last_call: moment(item.last_call),
        status: item.status === "HO" ? "On Hold" : this.getUserstatus(lastActivityDays),
        coach_notes: item.coach_notes,
        // on_obj: hasStepReflections ? (stepReflections["ON"] || "") : "",
        // as_obj: hasStepReflections ? (stepReflections["AS"] || "") : "",
        // tr_obj: hasStepReflections ? (stepReflections["TR"] || "") : "",
        // ti_obj: hasStepReflections ? (stepReflections["TI"] || "") : "",
        // rr_obj: hasStepReflections ? (stepReflections["RR"] || "") : "",
        // ri_obj: hasStepReflections ? (stepReflections["RI"] || "") : "",
        // co_obj: hasStepReflections ? (stepReflections["CO"] || "") : "",
        // ed_obj: hasStepReflections ? (stepReflections["ED"] || "") : "",
        // mi_obj: hasStepReflections ? (stepReflections["MI"] || "") : "",
        // nt_obj: hasStepReflections ? (stepReflections["NT"] || "") : "",
        // cp_obj: hasStepReflections ? (stepReflections["CP"] || "") : "",
        // cn_obj: hasStepReflections ? (stepReflections["CN"] || "") : "",
        // nr_obj: hasStepReflections ? (stepReflections["NF"] || "") : "",
        // ex_obj: hasStepReflections ? (stepReflections["LO"] || "") : "",
        // np_obj: hasStepReflections ? (stepReflections["NP"] || "") : "",
        // ps_obj: hasStepReflections ? (stepReflections["PS"] || "") : "",
        // re_obj: hasStepReflections ? (stepReflections["RE"] || "") : "",
        // cl_obj: hasStepReflections ? (stepReflections["CL"] || "") : "",
        // li_obj: hasStepReflections ? (stepReflections["LK"] || "") : "",
        // at_obj: hasStepReflections ? (stepReflections["AT"] || "") : "",
        // ir_obj: hasStepReflections ? (stepReflections["IR"] || "") : "",
        // bp_obj: hasStepReflections ? (stepReflections["BP"] || "") : "",
        // jr_obj: hasStepReflections ? (stepReflections["JR"] || "") : "",
        sip_obj: item.steps_in_progress?.length > 0 ? item.steps_in_progress : "",
        lsc_obj: item.last_step_completed?.length > 0 ? item.last_step_completed : "",
        rfr_obj: item.ready_for_review?.length > 0 ? item.ready_for_review : "",
        rac_obj: item.request_access?.length > 0 ? item.request_access : "",
      };


    });

    return (
      <div  className="parent-table-div">
        <div
          // onScroll={this.handleScroll}
          className="table-div"
        >
          {!this.state.loading ? (
            <Table
              columns={columns}
              dataSource={data}
              scroll={{ x: 100, y: 800 }}
              pagination={false}
              rowClassName={() => "coach-row"}
              components={{
                body: {
                  // wrapper: con,
                  row: rows,
                },
              }}
            />
          ) : (
             <>
              {/* <LoadingOutlined style={{ fontSize: 50, color: "#199094" }} /> */}
              <MyLoader />
            </>
          )}
          {/* {
            this.state.fullDataLoading && <LoadingOutlined style={{ fontSize: 50, color: "#199094" }} />
          } */}
        </div>
        {/* <div style={{padding: "20px", float: "right", position: "relative", zIndex: "999", display: "none" }}>
          <button type="primary" className="button-main load-all-users" onClick={this.loadAllUsers} style={{ cursor: 'pointer', display: "none" }}>Load all users</button>
        </div> */}
      </div>
    );
  }
}
